<template>
  <div class="article-thr">
    <div class="article-inner" v-if="publishContent.showRows==2" :style="articleInnerStyl">
      <div
        v-for="(item, index) in articleDataList"
        :key="index"
        @click="skipLinks(item)"
        class="article-box"
        :style="articleBoxStyl"
        @mouseover="overArticleItem(item)"
      >
           <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
              <div class="img" :class="`img${receiveProps.blockInstanceId}${index}`" :style="imageStyl">
        </div>
        <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] == 2|| item.selectType==2">
            <img src="../../asset/images/video-btn.png"
             alt="">
          </div>
           </div>
        <div class="article" v-if="
        (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
          <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
            {{item[showMainTile]}}
          </div>
          <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes&&item[showMainDesc]">
            {{item[showMainDesc]}}
          </div>
          <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
            <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
            <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="swiper-wrap" v-if="publishContent.showRows==1" :style="videoOverlyStyl">
      <div :class="`swiper-container swiper-container${receiveProps.blockInstanceId}`">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in articleDataList"
            :key="index"
            :style="swiperBoxStyl"
          >
              <div class="inner-swiper" @mouseover="overArticleItem(item)">
              <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
                <div class="image-swiper" @click="skipLinks(item)" :class="`img${receiveProps.blockInstanceId}${index}`" :style="imageStyl">
              </div>
              <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] == 2|| item.selectType==2">
            <img src="../../asset/images/video-btn.png"
            >
          </div>
              </div>
              <div class="article" v-if="
              (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
                <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
                  {{item[showMainTile]}}
                </div>
                <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes">
                  {{item[showMainDesc]}}
                </div>
                <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
                  <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime}}</span>
                  <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Add Arrows -->
      <div class="button-box">
        <div :class="`swiper-button-next${receiveProps.blockInstanceId}`" :style="nextBtnStyl"><img src="../../asset/images/right-btn.png" alt=""></div>
        <div :class="`swiper-button-prev${receiveProps.blockInstanceId}`" :style="prevBtnStyl"><img src="../../asset/images/left-btn.png" alt=""></div>
      </div>
    </div>
    <dyPaging :paging="paging" v-if="publishStyle.pagingStatus" />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import {commonClickFn, getData} from './commonModuleFn'
export default {
  name: "articleLR",
  props: {
    receiveProps: {
      type: [Object, Array],
      default: () => {},
    },
  },
  filters: {
    formatTime(val) {
      return (
        val.split(" ")[0].split("-").join("/") 
      );
    },
  },

  components:{
    dyPaging:()=>import('../components/paging')
  },
  computed: {
    mainTitle() {
      let { titleAlign, titleBold, titleColor, titleSize, oneGroupImageLeft, oneGroupBorder, titleLineHeight } = this.receiveProps.tempData.specialStyle;
      return {
        color: titleColor,
        fontSize: `${titleSize || 18}px`,
        fontWeight: titleBold? '700': "",
        textAlign: titleAlign,
        padding: !this.publishContent.includeItemsImageOrVideo&&Number(oneGroupImageLeft)&&oneGroupBorder?'16px 16px 0':
        this.publishContent.includeItemsImageOrVideo&&Number(oneGroupImageLeft)&&oneGroupBorder?'0 16px 0': '',
        marginTop: !this.publishContent.includeItemsImageOrVideo? '0': '16px',
        lineHeight: titleLineHeight
      };
    },
    descriptionTitle() {
      let { descSize, descColor, descBold, descAlign, oneGroupImageLeft, oneGroupBorder, descLineHeight } = this.receiveProps.tempData.specialStyle;
      return {
        color: descColor,
        fontSize: `${descSize || 14}px`,
        fontWeight: descBold? '700': '',
        textAlign: descAlign,
        padding: Number(oneGroupImageLeft)&&oneGroupBorder?'0 16px 0px':'',
        marginBottom: !this.publishContent.includeItemsImageOrVideo? '0': '8px',
        lineHeight: descLineHeight
      };
    },
    publishStyl(){
      let {  oneGroupImageLeft, oneGroupBorder } = this.receiveProps.tempData.specialStyle;
      return {
        padding: Number(oneGroupImageLeft)&&oneGroupBorder?'8px 16px 16px':'',
        paddingTop: !this.publishContent.includeItemsImageOrVideo?'8px': ''
      }
    },
    imageStyl() {
      let {imgBorder, imgRadius, imgShadow, imgBackgroundColor} = this.receiveProps.tempData.specialStyle;
      return {
        border: imgBorder? "1px solid #D6DEEA": '',
        borderRadius: imgRadius? "4px": '',
        boxShadow: imgShadow? "0px 0px 8px 0px rgba(0, 0, 0, 0.1)": '',
        backgroundColor: imgBackgroundColor,
        width: 'fit-content'
      };
    },
    articleBoxStyl() {
      // 判断上下图文   还是左图右文
      let { oneGroupBorder, oneGroupBGColor, oneGroupImageLeft, oneGroupBorderShadow, oneGroupBorderRadius } = this.receiveProps.tempData.specialStyle;
      return {
        border: oneGroupBorder? "1px solid #d6deea" : '',
        backgroundColor: oneGroupBGColor,
        padding: !Number(oneGroupImageLeft)? "16px": '', // 判断 普通状态下'16px' 当贴边的时候为''
        boxShadow: oneGroupBorderShadow?"0px 0px 16px 0px rgba(0, 0, 0, 0.1)": '', 
        borderRadius: oneGroupBorderRadius? "4px": '', // 判断是否是圆角
        "--article-box-hover": this.showPointer ? "pointer" : "",
        // width: Number(oneGroupImageLeft)? '368px': '336px',
      };
    },
    videoOverlyStyl(){
      return {
        "--video-overly-hover": this.showPointer ? "pointer" : "",
      }
    },
    swiperBoxStyl(){
      let { oneGroupBorder, oneGroupBGColor, oneGroupImageLeft, oneGroupBorderShadow, oneGroupBorderRadius } = this.receiveProps.tempData.specialStyle;
      return {
        border: oneGroupBorder? "1px solid #d6deea" : '',
        backgroundColor: oneGroupBGColor,
        padding: !Number(oneGroupImageLeft)? "16px": '', // 判断 普通状态下'16px' 当贴边的时候为''
        boxShadow: oneGroupBorderShadow?"0px 0px 16px 0px rgba(0, 0, 0, 0.1)": '', 
        borderRadius: oneGroupBorderRadius? "4px": '', // 判断是否是圆角
        "--swiper-box-hover": this.showPointer ? "pointer" : "",
      };
    },
    articleInnerStyl(){
      let { topBottomInterval } = this.receiveProps.tempData.specialStyle;
      return {
        "--grid-template-column": this.isBanner? '1fr 1fr': '1fr',
        "--grid-row-gap": `${topBottomInterval}px`
      }
    },
    nextBtnStyl(){
      return {
        backgroundImage: 'none',
        width: '24px',
        height: '48px',
        position: 'absolute',
        top: '37%',
        right: 0,
      }
    },
    prevBtnStyl(){
      return {
        backgroundImage: 'none',
        width: '24px',
        height: '48px',
        position: 'absolute',
        top: '37%',
        left: 0,
      }
    }
  },
  data() {
    return {
     showPointer: false,
      showContentType: '1',
      articleDataList: [],
      publishContent: this.receiveProps.tempData.specialData,
      buttonContent: this.receiveProps.tempData.buttonData,
      publishStyle: this.receiveProps.tempData.specialStyle,
      showImgUrl: '',
      showMainTile: '',
      showMainDesc: '',
      isFileType: '',
      isshowBtn: false,
      paging: {
        params: {
          pageNum: 1,
          pageSize: 10,
        },
        total: 0,
      },
    };
  },
  mounted() {
    this.getDataList()
    
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(`.swiper-container${this.receiveProps.blockInstanceId}`, {
        slidesPerView: 3,
        spaceBetween: 24,
        autoplay: true,
        navigation: {
         nextEl: `.swiper-button-next${this.receiveProps.blockInstanceId}`,
          prevEl: `.swiper-button-prev${this.receiveProps.blockInstanceId}`,
        },
      });
    },
    skipLinks(item) {
      commonClickFn(item, this.publishContent, this)
    },
    overArticleItem(item){
      // 直接调取有手指  自由设置看是否有链接
      let {showContentType} = this.receiveProps.tempData.specialData
      let {selectUrlType,selectType} = item
      if(showContentType != 2){ 
      if(selectUrlType|| selectType ==2){
        this.showPointer = true
        return 
      }
         this.showPointer = false
      } else {
        this.showPointer = true
      }
    },
    getDataList(){
       getData(this, 2)
    }
  },
};
</script>

<style lang="less" scoped>
.article-thr {
  margin: 0 auto;
  .article-inner {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 24px;
    grid-row-gap: var(--grid-row-gap);
    .article-box {
      display: flex;
      box-sizing: content-box;
      position: relative;
      height: fit-content;
      flex-direction: column;
      align-items: center;
      .img {
        font-size:0;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        
        .img-default{
          width: 100%;
          height: 100%;
        }
      }
      .video-overly{
          width: 64px;
          height: 64px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          img{
            width: 100%;
            height: 100%;
          }
        }
      &:hover{
        cursor: var(--article-box-hover);
      }
    }
  }
  .swiper-wrap {
    position: relative;
    margin: auto;
    &:hover{
      cursor: var(--video-overly-hover);
    }
    .swiper-slide {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .inner-swiper {
        .image-swiper {
          width: fit-content;
          overflow: hidden;
          font-size: 0;
          position: relative;
          
        }
        .video-overly{
          width: 48px;
          height: 48px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          img{
            width: 100%;
            height: 100%;
          }
        }
        &:hover{
          cursor: var(--article-box-hover);
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .button-box {
      z-index: 1;
       width: 100%;
       position: absolute;
       top: 27%;
       transform: translate( 0, -27%);
      .swiper-button-next {
        background-image: none;
        width: 24px;
        height: 48px;
        position: absolute;
        top: 37%;
        right: 0;
      }
      .swiper-button-prev {
         background-image: none;
        width: 24px;
        height: 48px;
        position: absolute;
        top: 37%;
        left: 0;
      }
      img{
        width: 100%;
        height: 100%;
      }
      /deep/ .swiper-button-disabled{
        pointer-events: auto!important; // 阻止swiper事件到达第一张 左右切换穿透
    }
    }
  }
  // 公用样式
  .article {
        // flex: 1;
        width: 100%;
        .main-title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          margin-bottom: 8px;
        }
        .description {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          word-break: break-all;
        }
        .publish-num{
          display: flex;
          align-items: center;
        }
        .publish-time {
          height: 20px;
          font: 400 14px PingFangSC-Regular, PingFang SC;
          color: #999999;
          line-height: 20px;
          margin-right: 24px;
        }
        .obser-num {
          height: 20px;
          font: 400 14px PingFangSC-Regular, PingFang SC;
          color: #666666;
          line-height: 20px;
          display: inline-flex;
          align-items: center;
          img{
            margin-right: 8px;
          }
        }
      }
}
</style>
